import { render } from "./PricingSection.vue?vue&type=template&id=7951b137&scoped=true"
import script from "./PricingSection.vue?vue&type=script&lang=js"
export * from "./PricingSection.vue?vue&type=script&lang=js"

import "./PricingSection.vue?vue&type=style&index=0&id=7951b137&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7951b137"]])

export default __exports__